<script>
import moment from "moment";
import findIndex from "lodash/findIndex";
export default {
  props: {
    agentTargetList: Array,
    onLoadAgentTarget: Function
  },
  data() {
    const ROLE_SUPER_ADMIN =
      localStorage.getItem("roles").indexOf("ROLE_SUPER_ADMIN") > -1;
    const ROLE_REGION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_REGION_MANAGER") > -1;

    return {
      ROLE_SUPER_ADMIN,
      ROLE_REGION_MANAGER,
      checkBoxSelect: true,
      addYearTarget: false,
      addYearTargetArray: [
        {
          label: "年度",
          keyName: "year",
          type: "select",
          children: []
        },
        {
          label: "销售目标",
          keyName: "targetNumber",
          type: "number"
        }
      ]
    };
  },
  methods: {
    async onAddTarget(form) {
      const updateData = {
        agentId: this.$route.params.agentId,
        year: form.year,
        targetNumber: form.targetNumber
      };
      const result = await this.$http.regionAddAgentYearTarget(updateData);
      if (result === "success") {
        this.$emit("onLoadAgentTarget");
      }
    },
    onClickEditBeginLevel(row) {
      row.editRow = true;
    },
    async EditBeginLevel(row, save) {
      if (save) {
        const agentId = this.$route.params.agentId;
        const formData = {
          agentAchievementId: row.id,
          remark: row.formValue
        };
        let data = await this.$http.regionUpdateAgentTarget(
          agentId,
          formData,
          true
        );
        if (data === "success") {
          this.$message.success("提交成功");
          row.remark = row.formValue;
          row.editRow = false;
        } else {
          this.$message.success("保存失败，请重试");
          ow.formValue = row.remark;
          row.editRow = false;
        }
      } else {
        row.formValue = row.remark;
        row.editRow = false;
      }
    },
    onClickAdd() {
      let targetList = [];
      for (let i = 0; i < 5; i++) {
        const year = moment()
          .add(i, "years")
          .year();
        const check = findIndex(this.agentTargetList, {
          year: `${year}`
        });
        if (check < 0) {
          targetList.push({
            label: year,
            keyName: year
          });
        }
      }
      if (targetList.length > 0) {
        this.addYearTargetArray = [
          {
            label: "年度",
            keyName: "year",
            type: "select",
            children: targetList
          },
          {
            label: "销售目标",
            keyName: "targetNumber",
            type: "number"
          }
        ];
        this.addYearTarget = true;
      } else {
        this.$message.warning("暂无可设置的年份");
      }
    }
  }
};
</script>

<template>
  <div class="AgentDetailYearTargetIndex">
    <DialogForm
      v-if="addYearTarget"
      formTitle="添加年度目标"
      :formInputArray="addYearTargetArray"
      @close="addYearTarget = false"
      @submitForm="onAddTarget"
    />
    <elementButton
      v-if="ROLE_REGION_MANAGER"
      size="medium"
      class="addYearTargetButton"
      @click="onClickAdd"
    >添加年度目标</elementButton>
    <el-table
      :data="agentTargetList"
      class="AgencyAccountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="year" align="left" label="年度" width="150"></el-table-column>
      <el-table-column prop="targetNumber" align="left" label="销售目标(疗程)" width="150"></el-table-column>
      <el-table-column prop="actualNumber" align="left" label="实际销量(疗程)" width="150"></el-table-column>
      <el-table-column prop="finishScore" align="left" label="完成程度" width="150"></el-table-column>
      <el-table-column v-if="ROLE_SUPER_ADMIN" prop="remark" align="left" label="备注"></el-table-column>
      <el-table-column v-if="ROLE_REGION_MANAGER" prop="remark" align="left" label="备注">
        <template slot-scope="scope">
          <span
            v-if="scope.row.editRow === false"
            class="editLevelSpan"
            @click="onClickEditBeginLevel(scope.row)"
          >
            {{scope.row.remark}}
            <i class="el-icon-edit editIcon"></i>
          </span>
          <span v-else class="editRowLevel">
            <el-input
              v-model="scope.row.formValue"
              type="textarea"
              :rows="2"
              size="mini"
              class="numberInput"
            ></el-input>
            <el-button
              @click="EditBeginLevel(scope.row,true)"
              size="mini"
              class="saveButton"
              type="primary"
            >保存</el-button>
            <el-button @click="EditBeginLevel(scope.row, false)" size="mini" class="cancelButton">取消</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.AgentDetailYearTargetIndex {
  .addYearTargetButton {
    margin: 10px 1.5%;
  }

  .AgencyAccountTable {
    margin: 20px auto;
    border: 1px;
    width: 97%;

    .checkBoxLabel {
      color: #303133;

      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .editLevelSpan {
      cursor: pointer;
      min-width: 200px;

      .editIcon {
        margin-left: 5px;
        color: #00c1de;
      }
    }

    .editRowLevel {
      display: inline-block;
      text-align: center;

      .numberInput {
        min-width: 80px;
      }

      .saveButton {
        background-color: #00c1de;
        border-color: #00c1de;
        color: #fff;
        margin-top: 5px;
      }

      .cancelButton {
        margin-top: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Agent/AchievementTarget.vue